/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiLivescoreDateOddsGet200Response } from '../models';
// @ts-ignore
import type { ApiLivescoreLiveGet200Response } from '../models';
/**
 * LivescoreApi - axios parameter creator
 * @export
 */
export const LivescoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateGet', 'date', date)
            const localVarPath = `/api/livescore/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateOddsGet', 'date', date)
            const localVarPath = `/api/livescore/{date}/odds`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/livescore/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LivescoreApi - functional programming interface
 * @export
 */
export const LivescoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LivescoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivescoreApi.apiLivescoreDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateOddsGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreDateOddsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivescoreApi.apiLivescoreDateOddsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreLiveGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreLiveGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LivescoreApi.apiLivescoreLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LivescoreApi - factory interface
 * @export
 */
export const LivescoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LivescoreApiFp(configuration)
    return {
        /**
         * Get matches for the provided date
         * @param {LivescoreApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet(requestParameters: LivescoreApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get odds for the provided date
         * @param {LivescoreApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet(requestParameters: LivescoreApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreDateOddsGet200Response> {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreLiveGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLivescoreDateGet operation in LivescoreApi.
 * @export
 * @interface LivescoreApiApiLivescoreDateGetRequest
 */
export interface LivescoreApiApiLivescoreDateGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof LivescoreApiApiLivescoreDateGet
     */
    readonly date: string
}

/**
 * Request parameters for apiLivescoreDateOddsGet operation in LivescoreApi.
 * @export
 * @interface LivescoreApiApiLivescoreDateOddsGetRequest
 */
export interface LivescoreApiApiLivescoreDateOddsGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof LivescoreApiApiLivescoreDateOddsGet
     */
    readonly date: string
}

/**
 * LivescoreApi - object-oriented interface
 * @export
 * @class LivescoreApi
 * @extends {BaseAPI}
 */
export class LivescoreApi extends BaseAPI {
    /**
     * Get matches for the provided date
     * @param {LivescoreApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */
    public apiLivescoreDateGet(requestParameters: LivescoreApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig) {
        return LivescoreApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get odds for the provided date
     * @param {LivescoreApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */
    public apiLivescoreDateOddsGet(requestParameters: LivescoreApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig) {
        return LivescoreApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LivescoreApi
     */
    public apiLivescoreLiveGet(options?: RawAxiosRequestConfig) {
        return LivescoreApiFp(this.configuration).apiLivescoreLiveGet(options).then((request) => request(this.axios, this.basePath));
    }
}

